export const levels = {
  URGENT: {
    zh: "严重",
    en: "Urgent"
  },
  IMPORTANT: {
    zh: "一般",
    en: "Important"
  }
}

export const orderStatuses = {
  PENDING: {
    zh: "待处理",
    en: "Pending"
  },
  PROCESSING: {
    zh: "处理中",
    en: "Processing"
  },
  PROCESSED: {
    zh: "已处理",
    en: "Processed"
  },
  CHECKING: {
    zh: "验证中",
    en: "Checking"
  },
  SUCCEED: {
    zh: "成功",
    en: "Succeed"
  },
  FAILED: {
    zh: "失败",
    en: "Failed"
  }
}